<template>
    <div class="table-container">
      <div class="table" >
        <h1> Top Contributors</h1>
        <table style="width:100%" v-if="tops.length">
          <tr>
            <th></th>
            <th></th>
            <th>Punch Count</th>
          </tr>
          <tr class="row" v-for="(top,index) in tops" :key="index">
            <td>
              <h3 style="margin:0px">{{index +1 }}</h3>
            </td>
            <td>
              <div class="usercell">
                <img class="profile-pic" :src="getProfilePic(top.user.profile_img_url)" />
                <p style="margin:0px">{{top.user.user_name}}</p>
              </div>
            </td>
            <td>
              <h3 style="margin:0px">{{top.total_punch_count}}</h3>
            </td>
          </tr>
        </table>
        <h2 class="empty" v-else>  No Activity </h2>

      </div>
      <div class="table">
        <h1> Latest Contributions</h1>
        <table style="width:100%" v-if="recents.length">
          <tr>
            <th></th>
            <th></th>

            <th>Punch Count</th>
          </tr>
          <tr class="row" v-for="(recent,index) in recents" :key="index">
            <td style="text-align:left;margin:0px;">{{getDate(recent.start_date)}}</td>
            <td>
              <div class="usercell">
                <img class="profile-pic" :src="getProfilePic(recent.user.profile_img_url)" />
                <p style="margin:0px">{{recent.user.user_name}}</p>
              </div>
            </td>
            <td class="punchcountcell">
              <h3 style="margin:0px">{{recent.punch_count}}</h3>
            </td>
          </tr>

        </table>
        <h2 class="empty" v-else>  No Activity </h2>


      </div>

    </div>
</template>

<script>

  import ta from 'time-ago'

  export default {
    name: 'LiveDisplay',
    props: {
      startdate: String,
      tops: Array,
      recents: Array
    },

    data() {
      return {
      }
    },
    computed: {
      query() {
        return "?start=" + this.startdate;
      }
    },

    methods: {
      getDate(date) {
        return ta.ago(new Date(date * 1000))
      },
      getProfilePic(pic) {
        return pic ? pic : require("@/assets/fightcamp.jpg")
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin: 100px 0px;
  }

  .table {
    flex: 0 1 500px;
    display: flex;
    flex-direction: column;
    margin: 10px 0px;
    padding: 10px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);

  }

  @media only screen and (min-width: 600px) {
    .table {
      margin: 40px;
    }
  }

  .usercell {
    display: flex;
    flex-direction: row;
    align-items: center;
  }


  .row {
    border: solid;

    border-width: 1px 0;

  }

  .profile-pic {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    background-color: black;
    border: none;
    margin: 10px 10px;

  }

  @media only screen and (min-width: 600px) {
    .profile-pic {
      margin: 10px 40px;
    }
  }

  td {
    margin: 100px;
  }
  .empty {
    color: #434343;
  }
</style>